import React from 'react';
import classNames from "classnames";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Types} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";
import API from "@beardeddevops/react.api";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbsStatic = [{
	name: 'Categories',
	url: '/videos/categories',
	icon: 'dashboard'
}];

export default class Categories extends Framework.Components.View {

	constructor(props) {
		super(props, 'categories');

		this.state = {
			...this.state,
			name: '',
		}
	}

	render() {
		return(

			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					{this.props.roles.includes(UserRoles.Admin) &&
						<>
							<Button onClick={this.toggle('modalCategoryAdd')} size={"sm"} color="primary">
								<i className="fa fa-users"/>&nbsp;&nbsp;Add Category
							</Button>
							<Button onClick={this.toggle('modalSubAdd')} size={"sm"} color="primary">
								<i className="fa fa-users"/>&nbsp;&nbsp;Add Sub Category
							</Button>
						</>
					}
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Category"}
					object={Objects.Category}
					history={history}
					toggle={this.state.modalCategoryAdd}
					reportClose={this.reportClose('modalCategoryAdd')}
					afterSave={this.refreshPage}
				/>
				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Sub Category"}
					object={Objects.SubCategory}
					history={history}
					toggle={this.state.modalSubAdd}
					reportClose={this.reportClose('modalSubAdd')}
					afterSave={this.refreshPage}
				/>
				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Categories" value="categories"/>
					<Tab label="Sub Categories" value="subs"/>
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'categories'})}>
					<Collections.Categories key={this.state.key}/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'subs'})}>
					<Collections.SubCategories key={this.state.key}/>
				</div>
			</div>


		)
	}
}